import React from 'react'; // eslint-disable-line
import {
  put, join, select, fork,
} from 'redux-saga/effects';
import nsToken from '@netsapiens/netsapiens-js/dist/token';
import _ from 'lodash';

import { Typography } from '@material-ui/core';
import fetchBoard from './services/board/fetchBoard';
import fetchCharts from './services/chart/fetchCharts';
import createChartService from './services/chart/createChart';
import updateBoardService from './services/board/updateBoard';

// eslint-disable-next-line import/no-cycle
import store from '../store';
import * as actions from '../state';
import { generateId } from '../utils';
import { changeBoard } from '../events';

const DEFAULT_CARD_HEIGHT = 6;
// const DEFAULT_CARD_WIDTH = 6;

let _boardTask;
let _chartsTask;

// const saveOtherBoard = (board) => {
//   store.dispatch(saveBoard(board));
// };

// eslint-disable-next-line consistent-return
export default function* createChart(event) {
  // const user = yield select(state => actions.readStateUser(state));
  const board = yield select(actions.readStateBoard);
  const charts = yield select(actions.readStateCharts);

  const { dashboard_id: dashboardId } = event.payload;
  const { intl } = event.payload;
  const { messages } = event.payload;

  const authToken = nsToken.getDecoded();

  let modifiedboard = null;
  let modifiedcharts = null;
  if (dashboardId && dashboardId !== board.id) {
    _boardTask = yield fork(fetchBoard, {
      ...authToken,
      userId: authToken.user,
      boardId: dashboardId,
    });

    _chartsTask = yield fork(fetchCharts, {
      ...authToken,
      userId: authToken.user,
      boardId: dashboardId,
    });

    yield join([
      _boardTask,
      _chartsTask,
    ]);

    modifiedboard = _boardTask.result();
    modifiedcharts = _chartsTask.result();
  } else {
    modifiedboard = board;
    modifiedcharts = charts;
  }

  // find the lowest occupied row. TODO: calculate highest available space that fits the incoming card
  let lowestRow = 0;
  if (modifiedboard?.layouts?.lg) {
    modifiedboard?.layouts?.lg?.forEach((gridItem) => {
      if (gridItem.i && gridItem.y + gridItem.h > lowestRow) {
        lowestRow = gridItem.y + gridItem.h;
      }
    });
  }

  // generate a placeholder ID, will be replaced after an ID is allocated by the API
  const placeholderId = `new_${generateId(4)}`;

  // set some defaults
  let type = 'new';
  let newCardHeight = DEFAULT_CARD_HEIGHT;
  let newCardWidth = DEFAULT_CARD_HEIGHT;

  // if createChart() was called with input params, use them
  if (event.payload) {
    if (event.payload.chart === 'Header') {
      type = 'Header';
      event.payload = null; //eslint-disable-line
    } else {
      if (event.payload.chart) {
        type = event.payload.chart.type; //eslint-disable-line
      }

      if (event.payload.height) {
        newCardHeight = event.payload.height;
      }

      if (event.payload.width) {
        newCardWidth = event.payload.width;
      }
    }
  }

  // build the layout's gridItem object for the new chart
  const gridParams = (type === 'Header') ? {
    w: 3,
    h: 1,
    x: 0,
    y: lowestRow,
    i: placeholderId,
  } : {
    w: newCardWidth,
    h: newCardHeight,
    x: 0,
    y: lowestRow,
    i: placeholderId,
  };

  const newChartName = (type === 'Header')
    ? intl.formatMessage({ ...messages.NEW_HEADER })
    : intl.formatMessage({ ...messages.NEW_CHART });

  // build out the new chart, either from passed in params or from defaults
  let newChart;
  if (event.payload && event.payload.chart) {
    // eslint-disable-next-line no-undef
    newChart = _.cloneDeep(event.payload.chart);
    newChart.id = placeholderId;
    newChart.grid = gridParams;
    newChart.dashboard_id = modifiedboard.id;
  } else {
    newChart = {
      id: placeholderId,
      new: true,
      type,
      name: newChartName,
      dashboard_id: board.id,
      data_sources: [],
      properties: [],
      grid: gridParams,
    };
  }

  if (type === 'Header') newChart.properties = { fontSize: 24 }; // not ideal but an easy way to insert the only Header prop

  modifiedcharts.push(newChart); // push new chart into charts list
  modifiedboard?.layouts?.lg?.push(gridParams); // push updated layout into the board

  if (board.id === modifiedboard.id) {
    yield put(actions.setCharts(modifiedcharts));
    yield put(actions.setBoard(modifiedboard));
    yield put(actions.editMode(true));
    // yield put(actions.isDirty(true));
  } else {
    // request to update a different board.
    // const saveBoardAgain = false;

    return createChartService({
      user: authToken.user,
      domain: authToken.domain,
      chart: newChart,
    }).then((newChartId) => {
      modifiedboard?.layouts?.lg?.forEach((gridItem) => { // search the layout for the placeholder, swap it
        if (gridItem.i === placeholderId) {
          // eslint-disable-next-line no-param-reassign
          gridItem.i = newChartId.toString(); // I dont know why gridItem.i needs to be a string, but it do
        }
      });

      return updateBoardService({
        user: authToken.user,
        domain: authToken.domain,
        board: modifiedboard,
      }).then(() => {
        store.dispatch(actions.showToaster({
          show: true,
          message: intl.formatMessage({ ...messages.CHART_COPIED }),
          type: 'success',
          action: (
            <Typography
              gutterBottom
              onClick={() => store.dispatch(changeBoard(modifiedboard.id))}
            />
          ),
        }));
      });
    });
  }

  /* attempt to scroll content container to bottom */
  setTimeout(() => { // put in a timeout so a render cycle can complete first
    try { // catch here because sometimes gridElement isn't found
      const containerElement = document.getElementById('content-container');
      const gridElement = document.getElementsByClassName('react-grid-layout')[0];
      containerElement.scrollTo(0, gridElement.scrollHeight + 350);
    } catch (e) {
      // i dont care do u
    }
  }, 1);
}
